import { Link, useSearchParams } from "react-router-dom";
import BlockerReasonsEditor from "./BlockerReasonsEditor";
import SignupOtpSettings from "./SignupOtpSettings";

export default function SettingsPage() {
  const [params] = useSearchParams();
  const signup = params.get("tab") === "signup";
  return <div className="pa-page-stack">
    <div className="pa-title-row"><h1>Settings</h1></div>
    <nav className="pa-tabs pa-org-tabs" aria-label="Platform settings">
      <Link to="?tab=blocker-reasons" aria-current={!signup ? "page" : undefined}>Blocker reasons</Link>
      <Link to="?tab=signup" aria-current={signup ? "page" : undefined}>Signup</Link>
    </nav>
    {signup ? <SignupOtpSettings /> : <BlockerReasonsEditor />}
  </div>;
}
